import _ from 'underscore';
import { useCallback, useContext, useMemo } from 'react';
import { ScopeContext } from '@bingads-webui-react/scope-service';
import { InstrumentationContext } from '@bingads-webui-react/hoc-with-instrumentation';
import { loadBusinessInfoRecommendation } from '@bingads-webui-campaign-react/pmax-lite-data';

export function useLoadBISuggestions() {
  const { scope } = useContext(ScopeContext);
  const {
    cid, aid,
  } = scope.values;

  const instrumentation = useContext(InstrumentationContext);
  const activity = useMemo(() => {
    if (instrumentation && instrumentation.pmaxLiteSignup) {
      const scenario = instrumentation.pmaxLiteSignup.create();
      return scenario.suggestion.create();
    }
    return { trace: _.noop, error: _.noop };
  }, [instrumentation]);

  const loadBISuggestions = useCallback((context) => {
    const {
      url,
      language,
    } = context.inputs;

    if (!url) {
      activity.trace('loadBISuggestions - url is empty');
      return Promise.resolve();
    }

    const payload = { url, language };

    activity.trace(`loadBISuggestions - payload: ${JSON.stringify(payload)}, cid: ${cid}, aid: ${aid}`);

    return loadBusinessInfoRecommendation(payload, cid, aid)
      .timeout(5000)
      .then((response) => {
        const {
          BusinessName,
          InternationalPhoneNumber,
          PhoneNumber,
          Addresses,
        } = response;

        return {
          businessName: BusinessName,
          businessAddress: _.first(Addresses),
          internationalPhoneNumber: InternationalPhoneNumber,
          phoneNumber: PhoneNumber,
        };
      })
      .catch((error) => {
        // Do not show error message to user since suggestion is nice to have
        activity.trace(`loadBISuggestions failed - error: ${JSON.stringify(error)}. payload: ${JSON.stringify(payload)}`);
      });
  }, [activity, aid, cid]);

  return {
    loadBISuggestions,
  };
}
